import Component from './group_billing.vue'
export default Component
